import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicCycleCompanyList from '../../RifoDesign/EpicCycleCompanyList/epic.cycle.company.list.vue';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicPageLegendCard from '../../RifoDesign/EpicPageLegendCard/epic.page.legend.card.vue';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';

@Component({
    components: {
        'layout': EpicStandardLayout
    }
})

export default class EpicTermsOfServicePage extends Vue {
    public created(): void {
    }
}
